import { Component, computed } from '@angular/core';
import { MmrService } from '../../services/mmr.service';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { FirstLetterCapitalisePipe } from '../../../../shared/pipes/firstLetterCapitilise';

@Component({
  selector: 'app-mmr-title-block',
  imports: [SkeletonLoaderComponent, FirstLetterCapitalisePipe],
  templateUrl: './mmr-title-block.component.html',
  styleUrl: './mmr-title-block.component.scss',
})
export class MmrTitleBlockComponent {
  protected viewModel = computed(() => {
    const planValue = this.mmrService.planClaimsDetails.plan;

    return {
      isLoading: planValue.isLoading(),
      planDetails: planValue.value(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
